var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('div', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("생성된 시간 확인")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v("생성된 시간을 확인한 후 면접 가능 시간이 맞으면 다음 단계로 넘어가 주세요.")])]), _c('v-card', {
    attrs: {
      "rounded": "lg",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-30 pa-lg-40"
  }, [_c('meeting-schedules-card', {
    attrs: {
      "meeting": _vm.value
    }
  })], 1)]), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("이전으로")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('save');
      }
    }
  }, [_c('span', [_vm._v("저장 후 다음으로")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }